import config from './package.json';
import { ModuleConfig } from '../../types/configTypes';
import myPrivilegesCardViewRegistry from '../../registries/MyPrivilegesCardViewRegistry';
import GeneralCardView from './containers/GeneralCardView';
import GeneralDetailsView from './containers/GeneralDetailsView';
import { GeneralFeatureIds } from '../../constants/constants';

GeneralFeatureIds &&
  GeneralFeatureIds.forEach((item) => {
    myPrivilegesCardViewRegistry.register(
      item,
      GeneralCardView,
      GeneralDetailsView,
      false,
      config.myPrivigesReducerSubName,
    );
  });

export default {
  config,
} as ModuleConfig;
